/* eslint-disable react-hooks/exhaustive-deps */
import {
  Chip,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Spinner from 'common/components/spinner/spinner';
import { GENERAL_TEXT_COLOR } from 'config/consts';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getListByUserId, setLoading } from './giveawayNumbersActions';

const ELEMENT_SIZE = 100000;

/**
 * Formata um número da sorte armazenado como inteiro para o padrão
 * "SS.EEEEE" (Loteria Federal Sindilegis BFF — 7 dígitos).
 *   1245678 → "12.45678"
 *   45678   → "00.45678"
 */
const formatLuckyNumber = (value) => {
  const n = parseInt(value, 10);
  if (Number.isNaN(n) || n < 0) return String(value || '');
  const series = String(Math.floor(n / ELEMENT_SIZE)).padStart(2, '0');
  const element = String(n % ELEMENT_SIZE).padStart(5, '0');
  return `${series}.${element}`;
};

const useStyles = makeStyles(() => ({
  root: {
    padding: '1rem',
    backgroundColor: 'transparent',
    minHeight: '80vh',
  },
  numberChip: {
    fontFamily: 'monospace',
    fontSize: 18,
    fontWeight: 'bold',
    letterSpacing: 2,
    padding: '4px 12px',
  },
  listItem: {
    padding: '12px 0',
  },
  giveawayTitle: {
    marginTop: '1.5rem',
    marginBottom: '0.5rem',
  },
}));

export function GiveawayNumbers(props) {
  const classes = useStyles();

  useEffect(() => {
    props.getListByUserId(props.auth.user.id);
  }, []);

  if (props.giveawayNumbers.loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '92%', backgroundColor: 'transparent' }}>
        <Spinner />
      </div>
    );
  }

  const numbers = props.giveawayNumbers.list?.content || [];

  if (numbers.length === 0) {
    return (
      <section className={classes.root}>
        <Typography variant="h5" gutterBottom style={{ color: GENERAL_TEXT_COLOR }}>
          Números da Sorte
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Você ainda não possui números da sorte. Participe das atividades para receber!
        </Typography>
      </section>
    );
  }

  // Group numbers by giveaway
  const grouped = {};
  numbers.forEach((item) => {
    const giveawayName = item.giveaway?.name || 'Promoção';
    if (!grouped[giveawayName]) {
      grouped[giveawayName] = [];
    }
    grouped[giveawayName].push(item);
  });

  return (
    <section className={classes.root}>
      <Typography variant="h5" gutterBottom style={{ color: GENERAL_TEXT_COLOR }}>
        Números da Sorte
      </Typography>
      <Typography variant="body2" color="textSecondary" style={{ marginBottom: '1rem' }}>
        Seus números da sorte no formato da Loteria Federal: 2 dígitos de série + 5 dígitos do bilhete (ex.: 12.45678).
      </Typography>

      {Object.entries(grouped).map(([giveawayName, items]) => (
        <div key={giveawayName}>
          <Typography
            variant="h6"
            className={classes.giveawayTitle}
            style={{ color: GENERAL_TEXT_COLOR }}>
            {giveawayName}
          </Typography>
          <List dense>
            {items.map((item) => (
              <React.Fragment key={item.id}>
                <ListItem className={classes.listItem}>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      <Chip
                        label={formatLuckyNumber(item.number)}
                        className={classes.numberChip}
                        color="primary"
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs>
                      <ListItemText
                        secondary={
                          item.shared_with_user_id
                            ? 'Número compartilhado (Indique e Concorra)'
                            : new Date(item.createdAt).toLocaleDateString('pt-BR')
                        }
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        </div>
      ))}
    </section>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    giveawayNumbers: state.giveawayNumbers,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListByUserId,
      setLoading,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(GiveawayNumbers);
